// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__bXDEW","Main_article":"Main_Main_article__84A6r"};